import { format, parseISO } from 'date-fns';

export const dateAndHour = (date) => format(parseISO(date), 'dd/MM/yyyy HH:mm');
export const dateAndSeconds = (date) =>
  format(parseISO(date), 'dd/MM/yyyy HH:mm:ss');
export const date = (date) => format(parseISO(date), 'dd/MM/yyyy');
export const ISOToInputFormat = (date) => format(parseISO(date), 'yyyy-MM-dd');
